import React from "react";
import styles from "../style/style";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select'
import JoditEditor from 'jodit-react';
import TimeSearchPicker from "./TimeSearchPicker";
const joditEditorConfig = {
    readonly: false, // enables editing
    height: 300,
    toolbarButtonSize: 'large',
    showCharsCounter: true,
    showWordsCounter: true,
    showXPathInStatusbar: false,
	buttons: [
		'bold', 'italic', 'underline', '|', 
		'ul', 'ol', '|', 
		'image', '|',
		'align', '|', 
		'undo', 'redo',
		'table', 'link'
	  ],
	  uploader: {
		insertImageAsBase64URI: true,
		imagesExtensions: ['jpg', 'png', 'jpeg', 'gif', 'svg', 'webp']
	  },
	  removeButtons: [
		'video', 'font', 'fontsize', 'superscript', 
		'subscript','speech','file', 'symbol'
	  ],
  };
const customStyles = {
	control: (base, state) => ({
		...base,
		borderColor: state.isFocused ? '#FF5956' : base.borderColor, // Change border color on focus
		boxShadow: state.isFocused ? '0 0 0 1px #FF5956' : base.boxShadow, // Optional: Add a slight shadow on focus
		':hover': {
			borderColor: '#FF5956', // Ensure border remains the same on hover
		}
	}),
	multiValue: (styles, { data }) => ({
		...styles,
		backgroundColor: '#FF5956',
		color: '#fff',
		borderRadius:'5px',
	}),
	multiValueLabel: (styles) => ({
		...styles,
		color: '#fff',
	}),
	multiValueRemove: (styles) => ({
		...styles,
		color: '#fff',
		':hover': {
			backgroundColor: '#FF5956',
			color: 'white',
		},
	}),
};
const CustomInputField = ({
	className,
	type,
	field,
	placeholder,
	label,
	value,
	error,
	onChange,
	onBlur,
	onKeyPress,
	extraComponent,
	options,
	accept,
	readOnly = false,
	required = false,
	afterComponent,
	filterDate,
	minDate,
	maxDate,
}) => (
	<div className={className}>
		{label?(<label className="text-[13px] font-[500] pl-2">{label.replace(/([a-z])([A-Z])/g, "$1 $2")}</label>):''}
		{extraComponent}
		{type === "select" ? (
			<select
				className={`${(extraComponent)?styles.inputicon:styles.input} ${
					error && "border border-red-400 rounded-[7px]"
				} ${readOnly && "cursor-not-allowed"}`}
				name={field}
				value={value}
				onChange={onChange}
				onBlur={onBlur}
				disabled={readOnly}
				required={required}
			>
				{/* <option value="">{placeholder}</option> */}
				{options?.map((opt) => (
					<option key={opt.value} value={opt.value} disabled={opt?.disabled || false}>
						{opt.label}
					</option>
				))}
			</select>
		) : type === "multiselect" ? (
			<Select
				className={`${
					error && "border border-red-400 rounded-[7px]"
				} ${readOnly && "cursor-not-allowed"}`}
				name={field}
				isMulti
				onChange={onChange}
				onBlur={onBlur}
				disabled={readOnly}
				required={required}
				options={options}
				classNamePrefix="select"
				value={value}
				styles={customStyles}
			/>
		) : type === "singleSelect" ? (
			<Select
				className={`${
					error && "border border-red-400 rounded-[7px]"
				} ${readOnly && "cursor-not-allowed"}`}
				name={field}
				onChange={onChange}
				onBlur={onBlur}
				disabled={readOnly}
				required={required}
				options={options}
				classNamePrefix="react-select"
				value={options.find((opt) => opt.value === value)}
				styles={customStyles}
				placeholder={placeholder}
			/>
		) : type === "file" ? (
			<input
				className={`${error && "border border-red-400 rounded-[7px]"} ${(extraComponent)?styles.inputicon:styles.input} ${readOnly && "cursor-not-allowed"} `}
				type="file"
				name={field}
				accept={accept || "image/*"}
				onChange={onChange}
				placeholder="Please Select an Image"
				readOnly={readOnly}
				required={required}
			/>
		) : type === "textarea" ? (
			<textarea
				className={`${error && "border border-red-400 rounded-[7px]"} ${(extraComponent)?styles.inputicon:styles.input} ${readOnly && "cursor-not-allowed"}`}
				type="text"
				value={value}
				name={field}
				onChange={onChange}
				onBlur={onBlur}
				placeholder={placeholder}
				cols={30}
				rows={2}
				readOnly={readOnly}
				required={required}
			/>
		) : type === "reach-textarea" ? (
			// <CKEditor
			// 	editor={ClassicEditor}
			// 	data={value || '<p></p>'}
			// 	onChange={onChange}
			// 	onBlur={onBlur}
			// />
			<JoditEditor
				value={value}
				config={joditEditorConfig}
				onBlur={onChange} // triggers when user leaves the editor
				onChange={onChange}
			/>
		) : type === "toggle-checkbox" ? (
			<label className="cursor-pointer block w-fit">
				<input type="checkbox" value='1' name={field} onChange={onChange} onBlur={onBlur} className="sr-only peer" checked={value} />
				<div className="relative w-11 h-6 bg-red-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-green-300 dark:peer-focus:ring-green-800 dark:bg-red-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-red-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-red-600 peer-checked:bg-green-600"></div>
				<span className="ms-3 text-sm font-medium text-red-900 dark:text-red-300"></span>
			</label>
		) : type === "timepicker" ? (
			<DatePicker name={field} selected={value} onChange={onChange} onKeyPress={onKeyPress} required={required} className={`${error && "border border-red-400 rounded-[7px]"} ${(extraComponent)?styles.inputicon:styles.input} ${readOnly && "cursor-not-allowed"}`} placeholderText={placeholder}  showTimeSelect
			showTimeSelectOnly timeIntervals={15} timeCaption="Time" dateFormat="hh:mm aa"/>
		) : type === "datepicker" ? (
			<DatePicker name={field} selected={value} onChange={onChange} onKeyPress={onKeyPress} required={required} className={`${error && "border border-red-400 rounded-[7px]"} ${(extraComponent)?styles.inputicon:styles.input} ${readOnly && "cursor-not-allowed"}`} placeholderText={placeholder}  dateFormat="dd-MM-yyyy" autoComplete="off" filterDate={filterDate} minDate={minDate}  maxDate={maxDate} highlightDates={[new Date()]}/>
		)  : type === "timeSearchPicker" ? (
			<TimeSearchPicker value={value} onChange={onChange} placeholder={placeholder} className={`${error && "border border-red-400 rounded-[7px]"} ${(extraComponent)?styles.inputicon:styles.input} ${readOnly && "cursor-not-allowed"}`}
			/>
		) : (
			<input
				placeholder={placeholder}
				type={type}
				name={field}
				value={value}
				onChange={onChange}
				onKeyPress={onKeyPress}
				onBlur={onBlur}
				checked={value}
				className={`${error && "border border-red-400 rounded-[7px]"} ${(extraComponent)?styles.inputicon:styles.input} ${readOnly && "cursor-not-allowed"}`}
				readOnly={readOnly}
				required={required}
			/>
		)}
		{afterComponent}
		<p className="text-red-400 mt-px text-[15px] capitalize">
			{error?.replace(/([a-z])([A-Z])/g, "$1 $2")}
		</p>
	</div>
);

const SecondCustomInputField = ({
	type,
	field,
	placeholder,
	label = true,
	value,
	error,
	onChange,
	onBlur,
	onKeyPress,
	extraComponent,
	options,
	accept,
	readOnly = false,
	afterComponent,
	customClass = '',
	filterDate,
	minDate,
	maxDate
}) => (
	<div>
		<div className="relative">
			{label?(<label className="text-[15px] font-[500] pl-2">{label}</label>):''}
			{extraComponent}
			{type === "select" ? (
			<select
				className={`${(extraComponent)?styles.slotinputicon:styles.input} ${
				error && "border border-red-400 rounded-[7px]"
				} ${readOnly && "cursor-not-allowed"}`}
				name={field}
				value={value}
				onChange={onChange}
				onBlur={onBlur}
				disabled={readOnly}
			>
				{options?.map((opt) => (
				<option key={opt.value} value={opt.value}>
					{opt.label}
				</option>
				))}
			</select>
			) : (
			<input
				placeholder={placeholder}
				type={type}
				name={field}
				value={value}
				onChange={onChange}
				onKeyPress={onKeyPress}
				onBlur={onBlur}
				checked={value}
				className={`${error && "border border-red-400 rounded-[7px]"}
				${(extraComponent)?styles.secondinputicon:styles.input}
				${readOnly && "cursor-not-allowed"}`}
				readOnly={readOnly}
			/>
			)}
			{afterComponent}
	  	</div>
	  	<p className="text-red-400 mt-px text-[15px] capitalize">
			{error?.replace(/([a-z])([A-Z])/g, "$1 $2")}
	  	</p>
	</div>
);

export {CustomInputField, SecondCustomInputField};